import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Button from '../../components/ui/Button';
import PetForm from './components/PetForm';

const PetNewPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-4">
      <Button
        variant="ghost"
        size="sm"
        leftIcon={ArrowLeft}
        onClick={() => navigate(-1)}
        className="self-start"
      >
        Volver
      </Button>
      <h1 className="text-2xl font-bold text-slate-900">Nueva mascota</h1>
      <PetForm />
    </div>
  );
};

export default PetNewPage;